import Vue from 'vue'
import Vuex from 'vuex'

import actor from '@/store/actor/index'
import common from '@/store/common/index'
import genre from '@/store/genre/index'
import horoscope from '@/store/horoscope/index'
import line from '@/store/line/index'
import lp from '@/store/lp/index'
import message from '@/store/message/index'
import page from '@/store/page/index'
import pageLp from '@/store/pageLp/index'
import point from '@/store/point/index'
import top from '@/store/top/index'
import user from '@/store/user/index'
import setting from '@/store/setting/index'
import support from '@/store/support'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    actor,
    common,
    genre,
    horoscope,
    line,
    lp,
    message,
    page,
    pageLp,
    point,
    top,
    user,
    setting,
    support
  }
})
